import React from 'react'

// Minimal markdown renderer for hint content. Supports:
//   - ![alt](url) images
//   - Paragraphs separated by blank lines
// Anything else renders as plain text.
export default function HintContent({ hint }) {
  if (!hint) return null

  const blocks = hint.split(/\n{2,}/)
  return (
    <div className="vocabulary-hint">
      {blocks.map((block, i) => renderBlock(block, i))}
    </div>
  )
}

function renderBlock(block, key) {
  const nodes = []
  const regex = /!\[([^\]]*)\]\(([^)]+)\)/g
  let lastIndex = 0
  let match

  while ((match = regex.exec(block)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(<span key={`t-${key}-${nodes.length}`}>{block.slice(lastIndex, match.index)}</span>)
    }
    const alt = match[1]
    const url = match[2]
    nodes.push(
      <div key={`i-${key}-${nodes.length}`}>
        <img src={url} alt={alt} loading="lazy" />
      </div>
    )
    lastIndex = regex.lastIndex
  }

  if (lastIndex < block.length) {
    nodes.push(<span key={`t-${key}-${nodes.length}`}>{block.slice(lastIndex)}</span>)
  }

  return <p key={key} style={{ margin: 0 }}>{nodes}</p>
}
